import { render, staticRenderFns } from "./profile-container-loader.vue?vue&type=template&id=f30f0710"
import script from "./profile-container-loader.vue?vue&type=script&lang=js"
export * from "./profile-container-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports